import { useEffect, useState } from "react";

import { endpoints } from "@/lib/api";
import { useSettings, buildWhatsAppUrl } from "@/lib/useSettings";
import Icon from "@/components/Icon";
import { Reveal } from "@/lib/motionSafe";
import QuoteForm from "@/components/QuoteForm";

export default function Contact() {
  const { settings } = useSettings();
  const [services, setServices] = useState([]);
  const s = settings || {};

  useEffect(() => {
    endpoints.services().then(setServices).catch(() => {});
  }, []);

  const whatsappUrl = buildWhatsAppUrl(s.whatsapp, s.whatsapp_prefill_ar);

  return (
    <div data-testid="page-contact">
      <section className="aman-hero relative pt-20 pb-16 md:pt-28 md:pb-20 overflow-hidden">
        <div className="aman-glow-orb -top-20 -end-20" aria-hidden="true" />
        <div className="max-w-4xl mx-auto px-6 md:px-10 text-center text-white relative">
          <Reveal>
            <span className="aman-tag mx-auto">اتصل بنا</span>
          </Reveal>
          <Reveal delay={120}>
            <h1 className="font-heading mt-5 text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight">
              نحن هنا لخدمتك
            </h1>
          </Reveal>
          <Reveal delay={220}>
            <p className="mt-4 text-slate-300 text-lg leading-relaxed">
              تواصل معنا مباشرة أو أرسل طلب عرض سعر وسنعاود التواصل معك خلال 24 ساعة.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-5 gap-10">
          {/* Contact info cards */}
          <div className="lg:col-span-2 space-y-4">
            {s.phone && (
              <Reveal>
                <a href={`tel:${s.phone}`} className="aman-card p-5 flex items-center gap-4" data-testid="contact-phone-card">
                  <div className="w-12 h-12 rounded-xl bg-[#0A1628] text-[#00E5FF] flex items-center justify-center">
                    <Icon name="phone" size={22} />
                  </div>
                  <div>
                    <div className="text-xs text-slate-500 font-medium">اتصل بنا</div>
                    <div className="font-heading font-bold text-[#0A1628] text-lg" dir="ltr">{s.phone}</div>
                  </div>
                </a>
              </Reveal>
            )}
            {s.whatsapp && (
              <Reveal delay={80}>
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="aman-card p-5 flex items-center gap-4" data-testid="contact-whatsapp-card">
                  <div className="w-12 h-12 rounded-xl bg-emerald-500 text-white flex items-center justify-center">
                    <Icon name="message-circle" size={22} />
                  </div>
                  <div>
                    <div className="text-xs text-slate-500 font-medium">واتساب</div>
                    <div className="font-heading font-bold text-[#0A1628] text-lg" dir="ltr">+{s.whatsapp}</div>
                  </div>
                </a>
              </Reveal>
            )}
            {s.email && (
              <Reveal delay={160}>
                <a href={`mailto:${s.email}`} className="aman-card p-5 flex items-center gap-4" data-testid="contact-email-card">
                  <div className="w-12 h-12 rounded-xl bg-[#0A1628] text-[#00E5FF] flex items-center justify-center">
                    <Icon name="mail" size={22} />
                  </div>
                  <div>
                    <div className="text-xs text-slate-500 font-medium">البريد الإلكتروني</div>
                    <div className="font-heading font-bold text-[#0A1628] text-base" dir="ltr">{s.email}</div>
                  </div>
                </a>
              </Reveal>
            )}
            {s.address_ar && (
              <Reveal delay={240}>
                <div className="aman-card p-5 flex items-start gap-4" data-testid="contact-address-card">
                  <div className="w-12 h-12 rounded-xl bg-[#0A1628] text-[#00E5FF] flex items-center justify-center shrink-0">
                    <Icon name="map-pin" size={22} />
                  </div>
                  <div>
                    <div className="text-xs text-slate-500 font-medium">العنوان</div>
                    <div className="font-heading font-bold text-[#0A1628]">{s.address_ar}</div>
                  </div>
                </div>
              </Reveal>
            )}
          </div>

          {/* Quote form */}
          <div className="lg:col-span-3">
            <Reveal delay={120}>
              <div className="rounded-3xl bg-slate-50 border border-slate-100 p-6 sm:p-10">
                <h2 className="font-heading text-2xl sm:text-3xl font-bold text-[#0A1628]">أرسل طلب عرض سعر</h2>
                <p className="text-slate-600 mt-2 text-sm">املأ الحقول التالية وسنعاود التواصل معك.</p>
                <div className="mt-6">
                  <QuoteForm services={services} testIdPrefix="quote-form-contact" />
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
